__webpack_require__.p = "https://test-admin.dev.dim.atea.com/";